import type { ApiEmpresa } from "features/empresa/types/ApiEmpresa";
import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import type { ApiBaseParams } from "std/api/types";

export function apiEmpresaGet(params?: ApiBaseParams): Promise<ApiEmpresa[]> {
	return newRequestMercurio({
		url: "Empresa/Empresa",
		type: "get",
		params,
	});
}
